<template lang="pug">
  .component-policy-button
    .dropdown-buttons
      ActionButton(:action="remove") Delete

</template>

<script>
  import PolicyReveal from '../../../../pages/backoffice/PolicyReveal'
  import ModalReveal from '../../foundation/ModalReveal'
  import ActionButton from '../ActionButton'
  import KeplerBackofficeSdk from '../../../../lib/kepler/backoffice'
  import MaggieHelper from '../../../../maggieHelper'
  import CouponReveal from '../../../../pages/backoffice/CouponReveal'

  export default {
    name: 'PaymentMethodButtons',
    components: {CouponReveal, PolicyReveal, ActionButton, ModalReveal},
    data() {
      return {}
    },
    created() {


    },

    methods: {
      remove() {
        return KeplerBackofficeSdk.payment_methods.select(this.item).remove(() => {
          MaggieHelper.notification('', 'Payment method deleted')
          this.$emit('refresh')
        })
      }
    },

    props: ['item']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PaymentMethodButtons.vue?57f7c29e